import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Text } from '@zillow/constellation-10';

import AppSelectors from '../../../../../selectors/AppSelectors';
import TourCardSelectable from '../../../../postingPath/TourCardSelectable';
import EmptyTours from '../EmptyTours';

import type { VrModelProps } from '../../../../../model/VrModel';

type Props = {
  vrModels: Array<VrModelProps>;
  onSelectTour: (vrModelId: string) => void;
  onViewTour: (vrModel: VrModelProps) => void;
  tourType: 'floorPlan' | 'unit' | 'amenity' | 'singleFamily';
  selectedVrModelId?: string;
};

const HELPER_TEXT = {
  floorPlan: 'Select a tour to showcase this floor plan.',
  unit: 'Select a tour to showcase this unit.',
  singleFamily: 'Only one 3d tour can be selected per property.',
};

const ROW_SIZE = 2;

const ZillowTours = ({
  vrModels = [],
  onSelectTour,
  onViewTour,
  tourType = 'floorPlan',
  selectedVrModelId = undefined,
}: Props) => {
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  if (vrModels.length === 0) {
    return <EmptyTours />;
  }

  const vrModelChunks = [];
  for (let i = 0; i < vrModels.length; i += ROW_SIZE) {
    vrModelChunks.push(vrModels.slice(i, i + ROW_SIZE));
  }

  return (
    <Box css={{ padding: '400' }}>
      {tourType !== 'amenity' && (
        <Text css={{ paddingBottom: '200' }} asChild>
          <p>{HELPER_TEXT[tourType]}</p>
        </Text>
      )}
      {vrModelChunks.map((vrModelChunk, chunkIndex) => (
        <Box
          css={{
            display: 'grid',
            gridTemplateColumns: { base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' },
            gap: '400',
            paddingBlock: '200',
          }}
          key={`tour-Flex-${chunkIndex}`}
        >
          {vrModelChunk.map((vrModel, vrModelIndex) => (
            <Box
              key={vrModel.vrModelId}
              css={{ gridColumnStart: !isScreenMobile && vrModelIndex % 2 ? '2' : '1', gridColumnEnd: 'span 1' }}
            >
              <TourCardSelectable
                vrModel={vrModel}
                isSelected={vrModel.vrModelId === selectedVrModelId}
                onView={() => onViewTour(vrModel)}
                onSelect={() => onSelectTour(vrModel.vrModelId || '')}
              />
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default ZillowTours;
